import TemplateComponentTab from "./templateComponentTab.container";

export default TemplateComponentTab;
